export const TSOUA_USER_ID = "OOcmabdQBxQqnICV2TUmbal5gZY2";
export const TSOUA_USER_EMAIL = "tsoua@supervision.earth";

export function isTsouaUser(
  uid?: string | null,
  email?: string | null
): boolean {
  if (uid === TSOUA_USER_ID) {
    return true;
  }
  return (email || "").toLowerCase() === TSOUA_USER_EMAIL;
}

export const TSOUA_IMAGE_MODAL_WIDTH = 880;
export const TSOUA_IMAGE_MODAL_ENLARGED_WIDTH = 860;
